import React, { memo, useState, useMemo } from 'react'
import * as queryString from 'query-string'

import { Flex, Box } from '../../components/FlexBox'
import H1 from '../../components/H1'
import Text from '../../components/Text'
import Fab from '../../components/Fab'
import Input from '../../components/Input'
import Select from '../../components/Select'
import Modal from '../../components/StyledModal'
// import { DoctorIcon, Avatar, PhoneIcon, EmailIcon, FavoriteIcon, ChatIcon, ShareIcon } from '../../components/Icons'
import CircularProgress from '../../components/CircularProgress'

import Observation from './Observation'

import { useQuery, useMutation } from '../../hooks/useApollo'
import { LIST_OBSERVATIONS } from './Gqls'

const filter = (observations, search) => {
  const filtered = observations
    .filter(item => {
      let condition = true
      if (condition) condition = search ? item.title.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : condition
      return condition      
    })
  const ordered = filtered.sort((a, b) => {
    if (a.id > b.id) return -1
    if (a.id < b.id) return 1
    return 0
  })

  return ordered.map(item => {
    const [date, time] = item.createdAt.split('T')
    const [year, month, day] = date.split('-')
    const [hour, minute, _] = time.split(':')
    return {...item, createdAt: `${day}/${month}/${year} ${hour}:${minute}`}
  })
}

const Observations = memo(({ id, data, message, client, navigate }) => {

  const { patient } = data

  const [search, setSearch] = useState('')
  const [sortBy, setSortBy] = useState('name') // id 

  const [editObservation, setEditObservation] = useState(null) // id 
  const [newObservationModalOpen, setNewObservationModalOpen] = useState(false)

  const [observations, setObservations] = useState(data.observations)

  const filtered = useMemo(() => filter(observations, search, sortBy), [observations, search, sortBy])
  
  const fetchObservations = async () => {
    const result = await client.query({ query: LIST_OBSERVATIONS, variables: { id }, fetchPolicy: 'network-only' })
    setObservations(result.data.observations)
  }

  const handleNew = () => {
    setNewObservationModalOpen(true)
  }

  return (
    <>
      <Box p={4}>
        <Box mb={2} cursor='pointer' onClick={() => navigate(`/pacientes/${patient.id}`)}>← Voltar</Box>
        
        <Box mb={4}>
          <H1>{patient.name} - Histórico de Observações</H1>
        </Box>

        <Flex>
          <Box mr={3}>
            <Input placeholder='Buscar...' value={search} onChange={e => setSearch(e.target.value)} />
          </Box>
        </Flex>

        {filtered.map(item => (
          <Flex onClick={() => setEditObservation(item)} ai='center' key={item.id} cursor='pointer' p={3} style={{borderBottom: '1px solid lightgrey'}}>
            {/* <Box mr={2}>
              <DoctorIcon />
            </Box> */}
            <Box>
            {item.createdAt} - {item.title}
            </Box>
            <Box ml={3}>
              <Text fs={12}>{item.description}</Text>
            </Box>
          </Flex>
        ))}
      </Box>

      <Fab onClick={handleNew} />

      {newObservationModalOpen &&
        <Modal
          clickOutsideDisabled={true}
          onCloseCompleted={() => setNewObservationModalOpen(false)}
          render={
            ({onRequestClose}) => (
              <Observation
                onRequestClose={onRequestClose}
                initialData={{ title: '', description: '', patient: patient.id }}
                onCompleted={() => { fetchObservations(); message('Salvo com sucesso!'); setNewObservationModalOpen(false) }}
              />
            )
          }
        />
      }

      {editObservation &&
        <Modal
          clickOutsideDisabled={true}
          onCloseCompleted={() => setEditObservation(null)}
          render={
            ({onRequestClose}) => (
              <Observation
                onRequestClose={onRequestClose}
                initialData={editObservation}
                onCompleted={() => { fetchObservations(); message('Salvo com sucesso!'); setEditObservation(null) }}
              />
            )
          }
        />
      }

    </>
  )

})

export default memo(props => {
  const { data, error, loading } = useQuery(LIST_OBSERVATIONS, { variables: { id: props.id } })
  if (error) return `Erro! ${error.message}`
  if (!data || loading) return <CircularProgress />
  return <Observations {...props} data={data} />
})
